import React from "react";

interface ErrorFallbackProps {
    correlationId?: string;
    message?: string;
    timestamp?: string;
}

const ErrorFallback: React.FC<ErrorFallbackProps> = ({ correlationId, message, timestamp }) => {
    return (
        <div className="wrapperError">
            <div className="errorContent row">
                <div className="logo col-md-5 col-sm-12 text-center">
                    <img
                        src="assets/error-illustration.png"
                        alt="Error"
                        className="img-responsive"
                    />
                </div>

                <div className="text col-md-7 col-sm-12 text-left">
                    <h2>Oops!</h2>
                    <p>Something went wrong</p>

                    {message && (
                        <div className="errorMessage">
                            <div><strong>TypeError:</strong></div>
                            <div className="errorMessageContent">{message}</div>
                        </div>
                    )}


                    {correlationId && (
                        <div className="errorIdSection">
                            <strong>Correlation ID:</strong>
                            <span className="correlationIdValue">{correlationId}</span>
                        </div>
                    )}


                    {timestamp && (
                        <div className="errorTimestamp">
                            <strong>Date and Time:</strong> {timestamp}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ErrorFallback;
